<template>
  <div id="tfooter" class="d-flex">
    <slot name="footer" :countItems="countItems">
      <div class="font-12 text-gray-800">
        <slot name="footer.prepend" />
      </div>

      <v-spacer />

      <div class="font-12 text-gray-800">
        <slot name="footer.append" />
      </div>

      <span class="font-12 text-gray-800 py-2 pr-3 pl-3">Total de Itens: {{ Helpers.formatarValor(countItems) }}</span>
    </slot>
  </div>
</template>

<script>
import Mixin from "./Mixin"

export default {
  name: "TFooter",
  mixins: [Mixin],
  props: {
    countItems: Number
  }
}
</script>

<style scoped>
#tfooter {
  border-top: 1px solid #e1dfdf;
  align-items: center;
}
</style>
